import { Component, input, output } from '@angular/core';
import { MatChip, MatChipAvatar } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-chip',
  imports: [MatIcon, MatChipAvatar, MatChip],
  templateUrl: './chip.component.html'
})
/**
 * Begründung: Allgemeine Komponente.
 */
export class ChipComponent {
  isDisabled = input<boolean>(false);
  title = input<string>();
  isHighlighted = input<boolean>(false);
  dataTestId = input<string>();
  avatarIcon = input<string>();
  avatarIconColor = input<string>('primary');
  clicked = output<void>();
}
